const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');
const { createTooltip } = require('../components/tooltips');

const analyticsEventBus = getAnalyticsEventBus();

/**
 * Appends message, shows alert and enables button
 *   @param {string} message - custom message to be shown
 */
function displayMessage(message) {
  $.spinner().stop();
  const defaultMessage =
    document.querySelector('.wishlist-item-cards')?.dataset.defaultErrorMsg ||
    document.querySelector('.add-to-wishlist--heart')?.dataset.defaultErrorMsg;
  const options = {
    type: 'wishlist',
    text: message || defaultMessage,
    position: 'minicart',
    clickClosure: true,
    showCloseBtn: true,
  };
  const toolTipWishlist = createTooltip(options);
  toolTipWishlist.show();
}

/**
 * Triggers Pdp Wishlist Heart update-from-cart event
 * with clicked product and it's variation group Id
 * If not in Pdp Page, there's no Vue component listening
 * @param {string} productId - product Id to check
 */
function updatePdpHeartFromCart(productId) {
  const { getVariationGroupId } = require('../common/helpers/productIdHelpers');
  const variationGroupId = getVariationGroupId(productId);
  $('body').trigger('wishlist-heart:update-from-cart', {
    productId,
    variationGroupId,
  });
}

/**
 * Updates cart and miniCart Add to Wishlist buttons
 * and adds or removes class 'add-to-wishlist--filled'
 * @param {string} pid - product id
 * @param {string} action - add or remove action
 */
function updateCartWishlistButtons(pid, action) {
  const cartButtons = document.querySelectorAll(
    `.cart__add-to-wishlist[data-pid="${pid}"]`
  );
  if (!cartButtons) {
    return;
  }
  cartButtons.forEach((button) => {
    if (action === 'remove') {
      button.classList.remove('add-to-wishlist--filled');
    } else if (action === 'add') {
      button.classList.add('add-to-wishlist--filled');
    }
  });
}

/**
 * Updates wishlist size in tab list item
 * @param {int} quantity - number of items in wishlist
 */
function updateWishlistSize(quantity) {
  $('.wishlist-size').html(`(${quantity})`);
}

/**
 * Makes the ajax call to add a product to Wishlist
 * @param {HTMLElement} button - The button clicked
 */
function addToWishlist(button) {
  const url = button.dataset.actionAdd;
  const { pid } = button.dataset;

  if (!url || !pid) {
    return;
  }

  $.spinner().start();
  button.setAttribute('disabled', true);

  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      pid,
    }),
  })
    .then((response) => response.json())
    .then((info) => {
      displayMessage(info.msg);
      if (info.success) {
        const isPdpHeart = button.classList.contains(
          'the-product-details__add-to-wishlist'
        );
        if (isPdpHeart) {
          $('body').trigger('wishlist-heart:updated', true);
        } else {
          updateCartWishlistButtons(pid, 'add');
          updatePdpHeartFromCart(pid);
          updateWishlistSize(info.wishlistQty);
        }
      }
    })
    .catch(() => {
      displayMessage();
    })
    .finally(() => {
      button.removeAttribute('disabled');
    });
}

/**
 * Makes the ajax call to remove a product from Wishlist
 * @param {HTMLElement} button - The button clicked
 * @param {string} pid - Product id to remove
 */
function removeFromWishlist(button, pid) {
  const url = button.dataset.actionRemove;
  const wishlistContext = button.classList.contains('remove-product--wishlist');

  if (!url || !pid) {
    return;
  }

  $.spinner().start();
  button.setAttribute('disabled', true);

  fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      pid,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      displayMessage(data.msg);
      if (data.success) {
        const isPdpHeart = button.classList.contains(
          'the-product-details__add-to-wishlist'
        );
        if (isPdpHeart) {
          $('body').trigger('wishlist-heart:updated', false);
        } else {
          updateCartWishlistButtons(pid, 'remove');
          updatePdpHeartFromCart(pid);
          updateWishlistSize(data.wishlistQty);
          if (wishlistContext) {
            $('body').trigger('wishlist:do-update');
          }
        }
      }
    })
    .catch(() => {
      displayMessage();
    })
    .finally(() => {
      button.removeAttribute('disabled');
    });
}

/**
 * Manages to add or remove product from Wishlist
 * @param {HTMLElement} button - The event object
 * @param {FullProduct} product The full product data
 */
function wishlistHandler(button, product) {
  if (
    button.classList.contains('add-to-wishlist--filled') ||
    button.classList.contains('add-to-wishlist__text--added')
  ) {
    removeFromWishlist(button, product.id);
    // Send info for Analytics
    analyticsEventBus.publish(analyticsEventBus.EVENTS.wishlistProductRemoved);
  } else {
    addToWishlist(button);
    // Send info to Analytics
    analyticsEventBus.publish(analyticsEventBus.EVENTS.wishlistProductAdded, {
      product,
    });
  }
}

/**
 * Reders the modal window for product variation to be edited.
 * @param {string} pid - product id to render
 * @param {string} requestUuid - product uuid to render
 * @param {string} selectedSize - selected size if has
 * @param {boolean} addToCart - modal is asked by addToCart button
 */
function renderModalElement(pid, requestUuid, selectedSize, addToCart) {
  if ($('#editWishlistProductModal').length !== 0) {
    $('#editWishlistProductModal').remove();
  }

  const getProductUrl = document
    .querySelector('.edit-add-to-wishlist')
    .getAttribute('href');

  fetch(getProductUrl, {
    method: 'POST',
    body: JSON.stringify({
      requestUuid,
      pid,
      selectedSize,
      addToCart,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      $('body').append(data.renderedTemplate);
      $('#editWishlistProductModal').modal('show');
      const selectedSizeInput = document.querySelector(
        `.product-quickview .size[data-size-id="${selectedSize}"] input`
      );
      if (selectedSizeInput) {
        selectedSizeInput.checked = true;
      }
    })
    .catch(() => {
      displayMessage();
    });
}

/**
 * Update wishlst item with the size selected in modal
 * It updates wishlist buttons and list size
 * @param {string} updateProductUrl - url
 * @param {string} pid - product id to update
 * @param {string} uuid - product uuid to update
 */
async function updateWishListItem(updateProductUrl, pid, uuid) {
  const form = {
    uuid,
    pid,
  };

  $.ajax({
    url: updateProductUrl,
    type: 'post',
    context: this,
    data: form,
    dataType: 'json',
    success(data) {
      const { previousProductId } = data;
      updateCartWishlistButtons(previousProductId, 'remove');
      updatePdpHeartFromCart(pid);
      updateWishlistSize(data.wishlistSize);
      const sizeError = document.querySelector(
        `.wishlist-size-error[data-pid="${previousProductId}"]`
      );
      if (sizeError) {
        sizeError.innerHTML = '';
      }

      if (data.error) {
        displayMessage(data.msg);
      }
    },
    error() {
      const message = $('.update-wishlist-product').data('error-msg');
      displayMessage(message);
    },
    complete() {
      $('#editWishlistProductModal').remove();
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    },
  });
}

/**
 * Show each item size error
 * @param {Array} itemIds - items with size unselected
 */
function showItemSizeErrors(itemIds) {
  const errorText =
    document.querySelector('.wishlistItemCards')?.dataset.sizeError;
  itemIds.forEach((itemId) => {
    const sizeError = document.querySelector(
      `.wishlist-size-error[data-pid="${itemId}"]`
    );
    if (sizeError) {
      sizeError.innerHTML = errorText;
    }
  });
}

/**
 * Checks if all wishlist cards are variants (size is selected)
 * @param {HTMLElement} shareButton - share button clicked
 * @returns {Array} itemsWithError - items without size
 */
function checkSizeInAllCards(shareButton) {
  const allListItemsCards = shareButton
    .closest('.wishlistItemCards')
    ?.querySelectorAll('.product-card--wishlist');
  const itemsWithoutSize = [];
  allListItemsCards.forEach((itemCard) => {
    const isVariant = itemCard.dataset.isVariant === 'true';
    const isAvailable = itemCard.dataset.availability === 'true';
    if (!isVariant && isAvailable) {
      // If not available it doesn't force size error
      itemsWithoutSize.push(itemCard.dataset.productId);
    }
  });
  return itemsWithoutSize;
}

/**
 * Fills modal text with url to share and
 * shows share wishlist Modal
 * @param {string} modalHtml modal html
 * @param {string} shareUrl share url
 */
function showShareWishlistModal(modalHtml, shareUrl) {
  $('body').append(modalHtml);
  const modal = $('#shareWishlistModal');
  modal.find('.share-url').val(shareUrl);
  modal.modal('show');
}

/**
 * Ajax call to get Share Wishlist Modal
 * @param {string} shareUrl share url
 */
function getShareWishlistModal(shareUrl) {
  const modal = $('#shareWishlistModal');
  if (modal.length > 0) {
    modal.remove();
  }

  const url = $('.btn-share-your-wishlist').attr('data-show-modal');
  fetch(url, {
    method: 'GET',
  })
    .then((response) => response.json())
    .then((data) => {
      showShareWishlistModal(data.modalHtml, shareUrl);
    })
    .catch(() => {
      displayMessage();
    });
}

/**
 * Gets base share url and adds timestamp parameter
 * @param {HTMLElement} button - Share wishlist button element
 * @returns {string} share url
 */
async function createShareUrl(button) {
  const url = button.dataset.action;

  return fetch(url, {
    method: 'GET',
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.error) {
        return { error: true, errorMsg: data.errorMsg };
      }
      return { succes: true, shareUrl: data.shareWishlistUrl };
    })
    .catch(() => ({ error: true }));
}

/**
 * Copies given text to the clipboard
 * and updates button text
 * @param {HTMLElement} button - Copy wishlist button element
 * @param {string} text - Share wishlist url
 */
function copyUrlToClipboard(button, text) {
  navigator.clipboard.writeText(text).then(
    () => {
      const textCopied = button.dataset.copiedText;
      // eslint-disable-next-line no-param-reassign
      button.innerText = textCopied;
    },
    () => {
      // Do nothing regardless of error
    }
  );
}

/**
 * Calls for browser native share function
 * If fails, shows share modal.
 * @param {string} shareUrl share url
 * @param {string} titleText title
 */
async function shareByBrowser(shareUrl, titleText) {
  await navigator.share({
    url: shareUrl,
    text: titleText,
  });
}

/** Cheks if native share is available
 * to use it , or show share modal instead.
 * @param {HTMLElement} button - Share wishlist button element
 */
async function shareWishlistHandler(button) {
  button.setAttribute('disabled', true);
  const result = await createShareUrl(button);

  if (result.error || !result.shareUrl || result.shareUrl === '') {
    displayMessage(result.errorMsg);
    button.removeAttribute('disabled');
    return;
  }

  if (navigator.share) {
    shareByBrowser(result.shareUrl, button.dataset.shareTitle);
  } else {
    getShareWishlistModal(result.shareUrl);
  }
  button.removeAttribute('disabled');
}

/**
 * Selects a size variant inside the wishlist edit modal and triggers
 * base.attributeSelect to update the product detail block.
 * @param {HTMLElement} sizeElement - clicked size label element inside modal
 * @returns {Promise<Object>} response from base.attributeSelect
 */
async function wishlistAttributeSelect(sizeElement) {
  const base = require('./base');
  $('#editWishlistProductModal').spinner().start();
  const input = sizeElement
    .closest('.size-row__container')
    .querySelector('.size-row__size-input');
  input.checked = true;
  const asyncResponse = await base.attributeSelect(
    input.dataset.attrUrl,
    $(sizeElement.closest('.product-detail'))
  );
  $('#editWishlistProductModal').spinner().stop();
  return asyncResponse;
}

module.exports = {
  methods: {
    addToWishlist,
    removeFromWishlist,
    updateWishlistSize,
    wishlistHandler,
  },
  pdpWishlistHeartEventHandler() {
    $('body').on('wishlist-heart:clicked', (e, data) => {
      const {
        getVariationGroupId,
      } = require('../common/helpers/productIdHelpers');
      const variationGroupId = getVariationGroupId(data.button.dataset.pid);
      wishlistHandler(data.button, data.product, variationGroupId);
    });
  },
  removeFronWishlistList() {
    $('body').on('click', '.remove-product--wishlist', (e) => {
      removeFromWishlist(e.currentTarget, e.currentTarget.dataset.pid);
      // Send info for Analytics
      analyticsEventBus.publish(
        analyticsEventBus.EVENTS.wishlistProductRemoved
      );
    });
  },
  viewProductViaEdit() {
    $('body').on('click', '.edit-add-to-wishlist', (e) => {
      e.preventDefault();
      const productCard = e.currentTarget.closest('.product-card');
      const selectedSize = productCard?.querySelector(
        '.product-attributes.size'
      )?.dataset.value;
      const editAddToWishlistElement = productCard?.querySelector(
        '.edit-add-to-wishlist'
      );
      if (!editAddToWishlistElement?.dataset) {
        return;
      }

      const { pid, uuid } = editAddToWishlistElement.dataset;
      renderModalElement(pid, uuid, selectedSize, false);
    });
  },
  updateWishListItemEvent() {
    $('body').on(
      'click',
      '.wishlist-edit-product-modal .size-row__size-label',
      async (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        const base = require('./base');

        // Atribute select
        const asyncResponse = await wishlistAttributeSelect(evt.target);

        // Update Wishlist
        const updateInfoBlock = evt.target
          .closest('.modal-body')
          .querySelector('.update-wishlist-product');
        const updatedPid = asyncResponse.product.id;
        await updateWishListItem(
          updateInfoBlock.value,
          updatedPid,
          updateInfoBlock.dataset.uuid
        );

        /**
         *  Add to cart, if needed, when Wishlist is updated
         */
        function addToCartWhenWishlistUpdated() {
          if (updateInfoBlock.dataset.addToCart === 'true') {
            const elementToAddToCart = document.querySelector(
              `.product-card--wishlist[data-product-id^="${updatedPid}"]`
            );
            base.methods.addToCartHandler(elementToAddToCart);
          }
          $('body').off('wishlist:updated', addToCartWhenWishlistUpdated);
        }

        $('body').on('wishlist:updated', addToCartWhenWishlistUpdated);
        $('body').trigger('wishlist:do-update');
      }
    );
  },
  checkBeforeAddToCart() {
    $('body').on('click', '.add-to-cart--btn-wishlist', (e) => {
      e.preventDefault();
      const productCard = e.currentTarget.closest('.product-card--wishlist');
      if (productCard?.dataset.isVariant !== 'true') {
        const selectedSize = productCard?.querySelector(
          '.product-attributes.size'
        )?.dataset.value;
        const editAddToWishlistElement = productCard?.querySelector(
          '.edit-add-to-wishlist'
        );
        if (!editAddToWishlistElement?.dataset) {
          return;
        }

        const { pid, uuid } = editAddToWishlistElement.dataset;
        renderModalElement(pid, uuid, selectedSize, true);
        e.stopPropagation();
      }
    });
  },
  checkBeforeShareWishlist() {
    $('body').on('click', '.btn-share-your-wishlist', (e) => {
      e.target
        .closest('.wishlist-container')
        ?.querySelector('.share-wishlist-error')
        ?.classList.remove('share-wishlist-error--show');
      const itemsWithError = checkSizeInAllCards(e.currentTarget);

      if (itemsWithError.length > 0) {
        e.target
          .closest('.wishlist-container')
          ?.querySelector('.share-wishlist-error')
          ?.classList.add('share-wishlist-error--show');
        showItemSizeErrors(itemsWithError, true);
        e.stopPropagation();
      } else {
        shareWishlistHandler(e.target);
      }

      // Send info for Analytics
      analyticsEventBus.publish(
        analyticsEventBus.EVENTS.wishlistShareButtonClicked
      );
    });
  },
  copyShareLinkEventListener() {
    $('body').on('click', '.btn-copy-link', (event) => {
      const shareUrl = event.target
        .closest('#shareWishlistModal')
        .querySelector('.share-url').value;
      copyUrlToClipboard(event.target, shareUrl);
    });
  },
};
